import type { FilterDTO, FilterItemDTO } from "../../search";
export abstract class SellerTypeTransformer {
  private static readonly mappedValues: Record<string, string> = {
    "locação de automóveis": "Veículos de Locadora",
  };
  static transform(filter: FilterDTO): FilterDTO {
    if (!filter || filter.name !== "SellerType") return filter;

    const transformedItems: FilterItemDTO[] = filter.items
      .map((item) => {
        const value = item.label?.toLocaleLowerCase();
        return {
          ...item,
          label: SellerTypeTransformer.mappedValues[value ?? ""] ?? item.label,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));

    return {
      ...filter,
      items: transformedItems,
    };
  }
  static transformFromUrl(
    sellerTypes: string[]
  ): Array<{ value: string; label: string }> {
    return sellerTypes.map((sellerType) => {
      const value = sellerType.toLocaleLowerCase();
      return {
        value: sellerType,
        label: SellerTypeTransformer.mappedValues[value] ?? sellerType,
      };
    });
  }
}
